import MortgageEarnLayout from '@/src/experiences/mortgage-earn/navigation/layout'

export { unstable_settings } from '@/src/experiences/mortgage-earn/navigation/layout'

type ExpoStackProps = Parameters<typeof MortgageEarnLayout>[0]['ExpoStackProps']

/**
 * Home layout delegates to MortgageEarn layout since they share the same navigation structure.
 * This maintains the existing behavior while following the experiences architecture pattern.
 */
export default function Layout(ExpoStackProps: ExpoStackProps) {
  return <MortgageEarnLayout ExpoStackProps={ExpoStackProps} />
}
